const fieldSelector = fieldObj => {
  return Object.keys(fieldObj).map(fieldKey => fieldObj[fieldKey]);
};

export default fieldSelector;
